import WizardDialog, { WizardModalDialogProps } from "designSystem/components/wizard/WizardDialog";
import { ButtonEnum } from "designSystem/types/button-types";
import { observer } from "mobx-react-lite";
import React, { Fragment, FunctionComponent } from "react";
import ExternalAPIWizardStore, { ExternalAPIWizardStoreContext } from "./ExternalAPIWizardStore";
import ExternalAPIConnectorPage from "./ExternalAPIConnectorPage";
import ExternalAPIParameterSetupPage from "./ExternalAPIParameterSetupPage";
import { Button, ConfirmDialog, ErrorDialog, MessageDialog } from "designSystem/index";

export const ExternalAPIConnectorWizard: FunctionComponent<WizardModalDialogProps<ExternalAPIWizardStore>> = observer((props) => {
	const {
		store,
		onClose,
		onSave,
		title,
		...otherProps
	} = props;

	const {
		errorMessage,
		externalAPIConnectorName,
		isCancelDialogOpen,
		isErrorDialogOpen,
		isLoadingDialogOpen,
		isSuccessDialogOpen,
		isWizardDialogOpen,
		onClickCloseError,
		onClickSuccess,
		resetWizard,
		cancelExternalAPIWizard,
	} = store || {};

	return (
		<>
			{store && (
				<ExternalAPIWizardStoreContext.Provider value={store}>
					{isWizardDialogOpen && (
						<WizardDialog
							pages={[ExternalAPIConnectorPage, ExternalAPIParameterSetupPage]}
							store={store}
							supportStepInformation
							titleRes="ConnectorSetup"
							width={800}
							{...otherProps}
						/>
					)}
					{isCancelDialogOpen && (
						<ConfirmDialog
							category="warn"
							confirmRes="BUTTON_CONFIRM"
							messageRes="ExternalAPIConnectorCancelSetup"
							onCancel={cancelExternalAPIWizard}
							onConfirm={onClose}
							open
							secondaryButtonRes="BUTTON_CLOSE"
							titleRes="ExternalAPIConnectorCancelSetupTitle"
						/>
            		)}
					{isErrorDialogOpen && (
						<ErrorDialog
							message={errorMessage}
							open
							titleRes="ExternalAPIConnectorErrorTitle"
						>
							{{
								buttons:
								<Fragment>
									<Button
										autoFocus
										design="primary"
										onClick={resetWizard}
										res={ButtonEnum.BUTTON_RETRY}
									/>
									<Button
										design="secondary"
										onClick={onClickCloseError}
										res={ButtonEnum.BUTTON_CANCEL}
									/>
								</Fragment>,
							}}
						</ErrorDialog>
					)}
					{isLoadingDialogOpen && (
						<MessageDialog
							category="progress"
							messageRes="ExternalAPIConnectorLoading"
							open
							titleRes="ExternalAPIConnectorLoadingTitle"
						/>
					)}
					{isSuccessDialogOpen && (
						<MessageDialog
							category="success"
							messageRes="ExternalAPIConnectorSuccess"
							messageResParams={[externalAPIConnectorName]}
							onClick={onClickSuccess}
							open
							titleRes="ExternalAPIConnectorSuccessTitle"
						/>
					)}
				</ExternalAPIWizardStoreContext.Provider>
			)}
		</>
	);
});

export default ExternalAPIConnectorWizard;